var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03841 0.40511C2.75228 0.138487 2.37383 -0.0066643 1.98279 0.00023516C1.59174 0.00713462 1.21865 0.165546 0.942097 0.442097C0.665546 0.718648 0.507135 1.09174 0.500235 1.48279C0.493336 1.87383 0.638487 2.25228 0.90511 2.53841L4.3667 6L0.90511 9.46159C0.638487 9.74772 0.493336 10.1262 0.500235 10.5172C0.507135 10.9083 0.665546 11.2814 0.942097 11.5579C1.21865 11.8345 1.59174 11.9929 1.98279 11.9998C2.37383 12.0067 2.75228 11.8615 3.03841 11.5949L6.5 8.1333L9.96159 11.5949C10.2477 11.8615 10.6262 12.0067 11.0172 11.9998C11.4083 11.9929 11.7814 11.8345 12.0579 11.5579C12.3345 11.2814 12.4929 10.9083 12.4998 10.5172C12.5067 10.1262 12.3615 9.74772 12.0949 9.46159L8.6333 6L12.0949 2.53841C12.3615 2.25228 12.5067 1.87383 12.4998 1.48279C12.4929 1.09174 12.3345 0.718648 12.0579 0.442097C11.7814 0.165546 11.4083 0.00713462 11.0172 0.00023516C10.6262 -0.0066643 10.2477 0.138487 9.96159 0.40511L6.5 3.8667L3.03841 0.40511Z",
    fill: "#FFFBF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXIcon);
export default __webpack_public_path__ + "static/media/close-x-icon.e3f6231182a5fa2f581d4101a1d7a571.svg";
export { ForwardRef as ReactComponent };